import axios from 'axios'
import { showToast } from 'vant'
import { API_BASE } from '@/utils/api-url'

const request = axios.create({
  baseURL: API_BASE,
  timeout: 15000
})

request.interceptors.response.use(
  response => {
    const result = response.data
    if (result?.code !== 0) {
      const message = result?.msg || '请求失败，请稍后重试'
      showToast({ message, type: 'fail' })
      return Promise.reject(new Error(message))
    }
    return result
  },
  error => {
    const message =
      error.response?.data?.msg ||
      (error.code === 'ECONNABORTED' ? '请求超时，请稍后重试' : '网络连接失败，请检查网络')
    showToast({ message, type: 'fail' })
    return Promise.reject(new Error(message))
  }
)

export default request
